import { render, staticRenderFns } from "./MenuForm.vue?vue&type=template&id=1c3fab82&"
import script from "./MenuForm.vue?vue&type=script&lang=js&"
export * from "./MenuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports